module.exports = __webpack_public_path__ + "static/img/圆心惠宝.dc315ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/cooperation/outer/圆心惠宝.png
// module id = YS6m
// module chunks = 0 1 2 9